import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
	max-height: 200px;
`;

export const TooltipWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 12px;
	overflow: auto;
`;

export const TooltipRowTitle = styled.div`
	display: flex;
	align-items: center;
	font-size: 11px;
	line-height: 16px;
	color: ${colors.grey5};
	padding-right: 16px;
`;

export const TooltipRowValue = styled.div`
	display: flex;
	align-items: center;
	font-size: 11px;
	color: ${colors.grey8};
	line-height: 16px;
	justify-content: flex-end;
`;

export const ColorWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const ColorSymbol = styled.div`
	min-width: 4px;
	max-width: 4px;
	min-height: 4px;
	max-height: 4px;
	background-color: ${({ color }) => color};
	border-radius: 50%;
`;

export const TooltipGrid = styled.div`
	display: grid;
	grid-template-columns: minmax(9px, 9px) 2fr 1fr;
	width: 100%;
	row-gap: 4px;
`;
